import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateCheckoutExperience = {
  name: "updateCheckoutExperience" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    name: z.string().optional(),
    addLandedCosts: z.boolean().optional(),
    fulfillmentDelayDaysOverride: z
      .union([
        z.object({ operation: z.literal("set"), value: z.number() }),
        z.object({ operation: z.literal("unset") }),
      ])
      .optional(),
  }),
  output: z.null(),
};
